module.exports = __webpack_public_path__ + "img/logo_propesca_texto.9795d8a3.svg";